type GameImage = {
  image?: unknown;
  images?: {
    portrait?: unknown;
    landscape?: unknown;
    square?: unknown;
  };
};

const asImageUrl = (value: unknown): string | undefined =>
  typeof value === "string" && value.trim() ? value : undefined;

export const getGameImage = (game: GameImage): string | undefined =>
  asImageUrl(game.image) ??
  asImageUrl(game.images?.portrait) ??
  asImageUrl(game.images?.landscape) ??
  asImageUrl(game.images?.square);
